import React from 'react';
import { whyChooseUs } from '../mock';
import { Scale, Users, Award, TrendingUp } from 'lucide-react';

const iconComponents = {
  Scale,
  Users,
  Award,
  TrendingUp
};

const AboutSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-[#FFB400] uppercase tracking-wide mb-2">
            ABOUT TRADEMARK ESSENTIAL
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#2B0A12] mb-4">
            Safeguarding Innovation. Protecting Identity.
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-stretch">
          {/* Left Content */}
          <div className="space-y-6 flex flex-col justify-center">
            <p className="text-lg text-gray-700 leading-relaxed">
              At Trademark Essential, we are dedicated to empowering innovators, entrepreneurs, and businesses with complete intellectual property protection. Our experienced attorneys provide personalized, strategic legal services to safeguard your ideas and brands.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              With extensive experience in intellectual property law, we've helped numerous clients secure their trademarks, copyrights, and patents while building strong legal foundations for their businesses. Our dedicated team provides personalized strategies tailored to your unique needs.
            </p>
            
            {/* Feature Grid Below Content */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-8">
              {whyChooseUs.map((feature) => {
                const IconComponent = iconComponents[feature.icon];
                return (
                  <div
                    key={feature.id}
                    className="bg-gradient-to-br from-[#2B0A12] to-[#3D1C24] p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105"
                  >
                    <div className="w-12 h-12 bg-[#FFB400] rounded-lg flex items-center justify-center mb-4">
                      <IconComponent className="h-6 w-6 text-[#2B0A12]" />
                    </div>
                    <h3 className="text-xl font-semibold text-[#F1F1F1] mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-gray-300 text-sm leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right Content - Full Height Image */}
          <div className="relative rounded-2xl overflow-hidden shadow-2xl h-full min-h-[600px]">
            <img 
              src="https://images.unsplash.com/photo-1758519288417-d359ac3c494d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxsZWdhbCUyMHRlYW18ZW58MHx8fHwxNzcwNjc3MzQ0fDA&ixlib=rb-4.1.0&q=85"
              alt="Legal Team - Trademark Essential"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#2B0A12]/60 via-transparent to-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;